import React from "react";
import { MdErrorOutline } from "react-icons/md";
const ErrorMessage = ({ children, errorStyle ="" }: { children: any, errorStyle?: string }) => {
  return (
    <span className={`text-[13px] font-medium text-[#D83F1D] inline-flex items-center mt-[4px]`}>
      <MdErrorOutline size={14} className={`mr-[4px] ${errorStyle}`} />
      <span>{children}</span>
    </span>
  );
};

export default ErrorMessage;
